import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import styles from "./styles.module.css";


import { UserContext } from "../../UserContext";
import { light } from "@material-ui/core/styles/createPalette";

const Sobre = () => {
    const { data, permission, modules } = React.useContext(UserContext);

    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    return (
        <main>

            <div id="main">

                <div class="breadcrumb-section">
                    <div class="container">
                        <h1>Sobre a clínica</h1>
                        <div class="breadcrumb">
                            <a href="index.html">Home</a>
                            <span class="fa fa-angle-double-right"></span>
                            <span class="current">Sobre a clínica</span>
                        </div>
                    </div>
                </div>


                <div class="container">



                    <section id="primary" class="content-full-width">

                        <div className="slider-container sobreClinica">
                            <Slider {...settings}>
                                <div>
                                    <img src="https://wedesignthemes.com/html/kidslife/images/activity1.jpg" className={styles.sliderImageSup} />
                                    <h2>Quem somos</h2>
                                    <p>A CreSer Clínica Multidisciplinar Infantojuvenil é especializada no atendimento de crianças e adolescentes, oferecendo serviços de nutrição infantil, avaliação neuropsicológica, pediatria, fisioterapia e psicopedagogia. Com uma equipe altamente qualificada, a CreSer se dedica a proporcionar um ambiente acolhedor e profissional para apoiar o desenvolvimento físico, cognitivo e emocional dos pacientes. Nosso compromisso é trabalhar de forma integrada com as famílias, ajudando a promover a saúde e o bem-estar infantojuvenil de maneira personalizada e eficaz.</p>
                                    {/* <a href="#" class="dt-sc-button small read-more"> Read More <span
                                        class="fa fa-chevron-circle-right"> </span></a> */}
                                </div>
                                <div>
                                    <img src="https://wedesignthemes.com/html/kidslife/images/activity2.jpg" className={styles.sliderImageSup} />
                                    <h2>Nosso espaço</h2>
                                    <p>A CreSer Clínica Multidisciplinar Infantojuvenil oferece um espaço acolhedor e funcional, pensado para garantir conforto e bem-estar aos nossos pacientes e suas famílias. Contamos com três salas de atendimento equipadas para diferentes especialidades, proporcionando um ambiente seguro e tranquilo para consultas e terapias. Nossa recepção é ampla e confortável, ideal para que os pais e acompanhantes possam aguardar com comodidade. Além disso, dispomos de um quintal ao ar livre, perfeito para atividades que exigem espaço e para momentos de descontração das crianças, tornando a experiência mais leve e prazerosa. Aqui, cada detalhe é pensado para que o cuidado com o desenvolvimento infantojuvenil seja completo.</p>
                                    {/* <a href="#" class="dt-sc-button small read-more"> Read More <span
                                        class="fa fa-chevron-circle-right"> </span></a> */}
                                </div>
                                <div>
                                    <img src="https://wedesignthemes.com/html/kidslife/images/activity3.jpg" className={styles.sliderImageSup}/>
                                    <h2>Missão</h2>
                                    <p>A missão da CreSer Clínica Multidisciplinar Infantojuvenil é promover o desenvolvimento integral de crianças e adolescentes, oferecendo cuidados especializados e personalizados que integram saúde física, cognitiva e emocional. Nosso objetivo é apoiar as famílias, fornecendo orientações e tratamentos de excelência que contribuem para o bem-estar e o crescimento saudável de nossos pacientes. Buscamos, acima de tudo, proporcionar um atendimento humanizado e acolhedor, sempre respeitando as particularidades de cada criança e suas necessidades individuais.</p>
                                    {/* <a href="#" class="dt-sc-button small read-more"> Read More <span
                                        class="fa fa-chevron-circle-right"> </span></a> */}
                                </div>
                                <div>
                                    <img src="https://wedesignthemes.com/html/kidslife/images/activity3.jpg" className={styles.sliderImageSup}/>
                                    <h2>Visão</h2>
                                    <p>A visão da CreSer Clínica Multidisciplinar Infantojuvenil é ser referência em cuidados integrados para o desenvolvimento infantojuvenil, reconhecida pela qualidade dos nossos serviços e pelo impacto positivo na vida das crianças, adolescentes e suas famílias. Almejamos expandir nosso alcance, inovando continuamente nas abordagens terapêuticas e educativas, e promovendo um ambiente onde o desenvolvimento saudável e o bem-estar sejam sempre priorizados. Queremos ser um modelo de excelência em atendimento multidisciplinar, inspirando confiança e contribuindo para a construção de um futuro mais saudável para nossos pacientes.</p>
                                    {/* <a href="#" class="dt-sc-button small read-more"> Read More <span
                                        class="fa fa-chevron-circle-right"> </span></a> */}
                                </div>
                                <div>
                                    <img src="https://wedesignthemes.com/html/kidslife/images/activity3.jpg" className={styles.sliderImageSup}/>
                                    <h2>Valores</h2>
                                    <p><b>Os valores da CreSer são: </b><br />1.	Amor e Cuidado: Tratamos cada paciente com carinho, atenção e dedicação, acreditando que o afeto é essencial para o desenvolvimento saudável.<br />
	2.	Respeito: Valorizamos a individualidade de cada criança e adolescente, respeitando suas diferenças, necessidades e tempo de crescimento.<br />
	3.	Humanização: Oferecemos um atendimento acolhedor e empático, priorizando o bem-estar emocional e físico de nossos pacientes e suas famílias.<br />
	4.	Excelência: Buscamos a mais alta qualidade em nossos serviços, com uma equipe qualificada e em constante aprimoramento.<br />
	</p>
                                    {/* <a href="#" class="dt-sc-button small read-more"> Read More <span
                                        class="fa fa-chevron-circle-right"> </span></a> */}
                                </div>
                                <div>
                                    <img src="https://wedesignthemes.com/html/kidslife/images/activity3.jpg" className={styles.sliderImageSup}/>
                                    <h2>Valores</h2>
                                    <p>
	5.	Compromisso com a família: Atuamos em parceria com as famílias, entendendo que sua participação ativa é fundamental no processo de cuidado e desenvolvimento.<br />
	6.	Ética: Agimos com transparência, responsabilidade e respeito em todas as nossas práticas, prezando pela confiança mútua.<br />
	7.	Inovação: Estamos sempre em busca de novas abordagens e ferramentas para garantir tratamentos atualizados e eficazes.<br />
	8.	Colaboração: Integramos diferentes especialidades para oferecer um atendimento completo e personalizado, sempre focado no desenvolvimento saudável da criança e do adolescente.</p>
                                    {/* <a href="#" class="dt-sc-button small read-more"> Read More <span
                                        class="fa fa-chevron-circle-right"> </span></a> */}
                                </div>

                            </Slider>
                        </div>
                        <div class="dt-sc-hr"></div>

                        <div class="dt-sc-one-half column first">
                            <h2>Comentário em destaque</h2>
                            <div class="author-details">
                                {/* <div class="author-thumb">
                                    <img class="item-mask"
                                        src="https://wedesignthemes.com/html/kidslife/images/author-hexa-bg.png" />
                                    <img src="https://wedesignthemes.com/html/kidslife/images/founder.jpg" />
                                </div> */}
                                <div class="author-description">
                                    <h5><a href>Thays Lisboa</a></h5>
                                    {/* <span class="author-role">Music Trainer, Specialist in <a href="#">Classical
                                        Music</a></span> */}
                                    {/* <a href="#" class="students-count"><span class="fa fa-user"></span> 25 STUDENTS</a>
                                    <div class="rating-review">
                                        <span class="author-rating rating-4"></span> <a href="#">2 reviews</a>
                                    </div> */}
                                    <p>Eu amei o espaço , fui muito bem recebida pela Jessica Psicóloga que eu amo muito , a Lorena já fez terapia com ela e nós amamos muito, inclusive a própria Lorena pede pra voltar , de tanto que amou. ♥️<br /><br />
Passamos a Lorena com a Pediatra Dra. Gabriela no último dia 31/agosto , uma consulta muito humanizada durou em torno de 1h.<br /><br />
A doutora muito atenciosa com atendimento excelente , perguntou tudo sobre a Lorena , sobre a saúde da nossa família.<br /><br />
Eu fiquei encantada com cuidado e atenção.<br /><br />
Pediu exames e iremos voltar em breve para retorno.<br /><br />
Obrigada clínica CreSer 🌷<br /></p>
                                </div>
                            </div>
                        </div>


                        <div class="dt-sc-one-half column">
                            <h2>Comentários do Google</h2>
                            <div class="dt-sc-testimonial-carousel-wrapper">
                            <div className="slider-container">
                            <Slider {...settings}>
                                <div>
                                <div class="dt-sc-testimonial">
                                            <blockquote><q>Atendimento impecável!!! Minhas filhas foram bem recebidas e assistidas durante a consulta. Doutora é o sonho de qualquer mãe, não sai do consultório sem alguma dúvida tirada. Nota 10!!! Indico muito !!</q></blockquote>
                                            {/* <div class="author">
                                                <img src="https://wedesignthemes.com/html/kidslife/images/parent.jpg" />
                                            </div> */}
                                            <div class="author-meta">
                                                <p> Thaina Souza </p>
                                                {/* <span>CEO &amp; Founder - Dhoom Inc</span> */}
                                                <span class="author-rating rating-5"></span>
                                            </div>
                                        </div>
                                </div>
                                <div>
                                <div class="dt-sc-testimonial">
                                            <blockquote><q>Estive na clínica Crescer com meu filho na consulta com a pediatra Dra Gabriela e foi simplesmente incrível, atendimento impecável des da hora que a gente chega até a hora de ir embora, a consulta com ela foi muito esclarecedora tirou todas minhas dúvidas! Adorei tudo estão de parabéns</q></blockquote>
                                            {/* <div class="author">
                                                <img src="https://wedesignthemes.com/html/kidslife/images/parent.jpg" />
                                            </div> */}
                                            <div class="author-meta">
                                                <p> Andressa Ribeiro </p>
                                                {/* <span>CEO &amp; Founder - Dhoom Inc</span> */}
                                                <span class="author-rating rating-5"></span>
                                            </div>
                                        </div>
                                </div>
                                <div>
                                <div class="dt-sc-testimonial">
                                            <blockquote><q>Gente sem palavras essa clínica é a melhor, lugar muito acolhedor a Jessica silvestre sem palavras meu filho fez tratamento com ela 1 ano e ela foi fantástica pra recuperação dele hoje tenho que trazer ele pra ver ela porque ele sente falta dela ela se tornou a melhor amiga dele o João Lucas ama ela</q></blockquote>
                                            {/* <div class="author">
                                                <img src="https://wedesignthemes.com/html/kidslife/images/parent.jpg" />
                                            </div> */}
                                            <div class="author-meta">
                                                <p> Juliane Gomes </p>
                                                {/* <span>CEO &amp; Founder - Dhoom Inc</span> */}
                                                <span class="author-rating rating-5"></span>
                                            </div>
                                        </div>
                                </div>
                                <div>
                                <div class="dt-sc-testimonial">
                                            <blockquote><q>Ferraz precisava muito de um lugar tão completo assim. Multidisciplinar, profissionais MARAVILHOSAS, atendimento mais que humanizado, ambiente gostoso para nossos pequenos (e para nós, papais, também 🥰), a consulta então... 🤩. Recomendo sem sombra de dúvidas 💜💜💜</q></blockquote>
                                            {/* <div class="author">
                                                <img src="https://wedesignthemes.com/html/kidslife/images/parent.jpg" />
                                            </div> */}
                                            <div class="author-meta">
                                                <p> Aline Strajaneli </p>
                                                {/* <span>CEO &amp; Founder - Dhoom Inc</span> */}
                                                <span class="author-rating rating-5"></span>
                                            </div>
                                        </div>
                                </div>
                                

                            </Slider>
                        </div>
                        <a href="https://www.google.com/search?q=clinica+crescer+ferraz+de+vasconcelos&rlz=1C1GCEU_pt-BRBR1038BR1038&oq=cli&gs_lcrp=EgZjaHJvbWUqCAgAEEUYJxg7MggIABBFGCcYOzITCAEQLhjHARixAxjJAxjRAxiABDIGCAIQRRg5MgYIAxAjGCcyBggEEEUYPTIGCAUQRRg8MgYIBhBFGD0yBggHEEUYPNIBCDE0MDlqMGo0qAIAsAIB&sourceid=chrome&ie=UTF-8&lqi=CiVjbGluaWNhIGNyZXNjZXIgZmVycmF6IGRlIHZhc2NvbmNlbG9zSK_dt9T7uoCACFozEAAQARgAGAIYAxgEIiVjbGluaWNhIGNyZXNjZXIgZmVycmF6IGRlIHZhc2NvbmNlbG9zkgEUbWVudGFsX2hlYWx0aF9jbGluaWOaASNDaFpEU1VoTk1HOW5TMFZKUTBGblNVTnlOWFI2WTJWQkVBRaoBYxABKhMiD2NsaW5pY2EgY3Jlc2NlcigMMh8QASIbSd9-Lret_3-zOeHLI3nmuA9Z3jOyJNDPZ3MLMikQAiIlY2xpbmljYSBjcmVzY2VyIGZlcnJheiBkZSB2YXNjb25jZWxvc_oBBAgZEEI#rlimm=14524720531303045889" target="_blank" class="dt-sc-button small read-more"> Confira no Google <span
                                        class="fa fa-chevron-circle-right"> </span></a>
                                
                                <div class="carousel-arrows">
                                    <a href="#" class="testimonial-prev"><span class="fa fa-angle-left"></span></a>
                                    <a href="#" class="testimonial-next"><span class="fa fa-angle-right"></span></a>
                                </div>
                            </div>
                        </div>

                        <div class="dt-sc-hr"></div>
                    </section>

                </div>

            </div>


        </main>

    );

};


export default Sobre;
